export class PlanCommands {
  public static readonly availableQuotaChanged =
    'plan_notifyAvailableQuotaChanged';
}
